import { GroupBase, MultiValueProps, components } from "react-select";
import { SelectItem } from "../Select";

const MultiValue = (
  props: MultiValueProps<SelectItem, false, GroupBase<SelectItem>>,
) => <components.MultiValue {...props}>{props.children}</components.MultiValue>;

export default MultiValue;
